<template>
  <section class="pt-5 mb-4">
    <div class="container">
      <div class="row">
        <div class="col-xl-8 mx-auto">
          <div class="row aiz-steps arrow-divider">
            <div :class="getClass(1)" class="col">
              <div
                :class="getClass2(1)"
                class="text-center"
                @click="jump('/user/cart')"
              >
                <i
                  :class="getClass3(1)"
                  class="la-3x mb-2 las la-shopping-cart"
                ></i>
                <h3
                  :class="getClass3(1)"
                  class="fs-14 fw-600 d-none d-lg-block"
                >
                  1. {{ $t("我的购物车") }}
                </h3>
              </div>
            </div>
            <div
              :class="getClass(2)"
              class="col"
              @click="
                userCartItemCount
                  ? jump('/user/checkout')
                  : $toast($t('您的购物车是空的'))
              "
            >
              <div :class="getClass2(2)" class="text-center">
                <i :class="getClass3(2)" class="la-3x mb-2 las la-map"></i>
                <h3
                  :class="getClass3(2)"
                  class="fs-14 fw-600 d-none d-lg-block"
                >
                  2. {{ $t("发货信息") }}
                </h3>
              </div>
            </div>
            <div
              :class="getClass(3)"
              class="col"
              @click="
                userCartItemCount
                  ? jump('/user/checkout/delivery_info')
                  : $toast($t('您的购物车是空的'))
              "
            >
              <div :class="getClass2(3)" class="text-center">
                <i :class="getClass3(3)" class="la-3x mb-2 las la-truck"></i>
                <h3
                  :class="getClass3(3)"
                  class="fs-14 fw-600 d-none d-lg-block"
                >
                  3. {{ $t("交货信息") }}
                </h3>
              </div>
            </div>
            <div :class="getClass(4)" class="col">
              <div :class="getClass2(4)" class="text-center">
                <i
                  :class="getClass3(4)"
                  class="la-3x mb-2 las la-credit-card"
                ></i>
                <h3
                  :class="getClass3(4)"
                  class="fs-14 fw-600 d-none d-lg-block"
                >
                  4. {{ $t("付款") }}
                </h3>
              </div>
            </div>
            <div :class="getClass(5)" class="col">
              <div :class="getClass2(5)" class="text-center">
                <i
                  :class="getClass3(5)"
                  class="la-3x mb-2 las la-check-circle"
                ></i>
                <h3
                  :class="getClass3(5)"
                  class="fs-14 fw-600 d-none d-lg-block"
                >
                  5. {{ $t("确认") }}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    step: Number
  },
  methods: {
    getClass(index) {
      if (index < this.step) {
        return { done: true };
      } else if (index === this.step) {
        return { active: true };
      }
    },
    getClass2(index) {
      if (index < this.step) {
        return { "text-success": true };
      } else if (index === this.step) {
        return { "text-primary": true };
      }
    },
    getClass3(index) {
      if (index > this.step) {
        return { "opacity-50": true };
      }
    }
  }
};
</script>
